import React from 'react';
import CountdownCard from './components/CountdownCard';
import CopyImageButton from './components/CopyImageButton';

function App() {
  return (
    <div className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      {/* Background Image Container */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1585464231875-d9ef1f5ad396?q=80&w=2070&auto=format&fit=crop"
          alt="Angel of Independence, Mexico City"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"></div>
      </div>

      {/* Copy Button — top right */}
      <div className="absolute top-4 right-4 z-20">
        <CopyImageButton />
      </div>

      {/* Main Content Area */}
      <div className="relative z-10 w-full flex justify-center items-center p-4">
        <CountdownCard />
      </div>
    </div>
  );
}

export default App;